(function () {
    'use strict';

    angular
        .module('app.deleteCustomReport')
        .factory('deleteCustomReportService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function deleteCustomReport(report_id, selected_company_id, loader) {
                    var url_deleteCustomRerpot = $rootScope.apiUrl + 'measure/deleteCustomReport/' + report_id + '/' + selected_company_id;
                    return handleRequest(url_deleteCustomRerpot, 'DELETE', null, loader);
                }

                service.deleteCustomReport = deleteCustomReport;

                return service;
            }
        ]);
})();
